<script setup lang="ts">
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';

import { routenames } from '@/router/routenames';
import Eula from './components/Eula.vue';
import { useAccountStore } from '@/stores/accountStore';
import { api } from '@/api';
import { useRouter } from 'vue-router';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';

const router = useRouter();

const accountStore = useAccountStore();

function declineHandler() {
  router.push({ name: routenames.signOut });
}

async function acceptHandler() {
  const userId = accountStore.currentUser?.id;
  if (!userId) {
    return;
  }

  const acceptresultEula = await api.account.acceptEula();

  if (acceptresultEula.success) {
    await accountStore.fetchAccountData(userId);
    router.push({ name: routenames.home });
  }
}
</script>

<template>
  <form class="form" @submit="() => console.log('foo')">
    <BasePage>
      <template #title>
        <BasePageTitle :title="$t('EndUserLicenseAgreement')" />
      </template>

      <template #actions>
        <PtwBackButton
          v-if="accountStore.currentUser?.eulaAccepted"
          :disabled="!accountStore.currentUser?.eulaAccepted"
          @click="router.back()"
        />
      </template>

      <div class="flex items-center justify-center h-100">
        <Eula
          style="height: 1000px"
          :showAcceptDeclineButtons="!accountStore.currentUser?.eulaAccepted"
          @decline="declineHandler"
          @accept="acceptHandler"
        />
      </div>
    </BasePage>
  </form>
</template>
